module.exports = __webpack_public_path__ + "img/castle.8c62320f.png";